import React from 'react';
export function ColombiaFlag({
  className = 'h-4 w-6'
}: {
  className?: string;
}) {
  return <span className={`inline-flex shrink-0 flex-col overflow-hidden rounded-[3px] ${className}`} aria-hidden="true" data-id="element-16" data-mp="2o6lqhxd3bqb3">
      <span className="flex-[2] bg-[#fcd116]" data-id="element-17" data-mp="2jeu7q906eovi" />
      <span className="flex-1 bg-[#003893]" data-id="element-18" data-mp="2ehlo03zdqcs5" />
      <span className="flex-1 bg-[#ce1126]" data-id="element-19" data-mp="2egiyo0hpgiec" />
    </span>;
}